import Vue from 'vue';
import axios from 'axios';

// noinspection JSIncompatibleTypesComparison
const isDevelopmentMode = process.env.NODE_ENV === 'development';

// base URL for backend access
const backendUrl = (isDevelopmentMode)
  ? 'http://localhost:8081/'
  : '/backend/';

// register axios as HTTP client
// see https://vuejs.org/v2/cookbook/adding-instance-properties.html#Real-World-Example-Replacing-Vue-Resource-with-Axios
Vue.prototype.$http = axios.create({
  baseURL: backendUrl,
  withCredentials: isDevelopmentMode,
});
